export default function Header() {
  return (
    <header className="bg-black shadow-lg sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <div className="flex items-center gap-6">
            <img 
              src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/550d2e7295433d49905bc8b37a9be776.png" 
              alt="FREE SKI ORELLE" 
              className="h-20 w-auto"
            />
            <img 
              src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/78cbdae630ee573145ac8da1396b3265.png" 
              alt="ESF ORELLE" 
              className="h-20 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a 
              href="tel:+33479567411" 
              className="flex items-center text-white hover:text-gray-300 font-medium transition-colors cursor-pointer whitespace-nowrap tracking-wide text-sm"
            >
              <div className="w-8 h-8 flex items-center justify-center mr-2">
                <i className="ri-phone-line text-xl"></i>
              </div>
              +33 4 79 56 74 11
            </a>
            <a href="#services" className="text-white hover:text-gray-300 font-medium transition-colors cursor-pointer whitespace-nowrap tracking-wide uppercase text-sm">
              Nos Services
            </a>
            <a href="#about" className="text-white hover:text-gray-300 font-medium transition-colors cursor-pointer whitespace-nowrap tracking-wide uppercase text-sm">
              À Propos
            </a>
            <a href="#contact" className="bg-white text-black px-8 py-3 font-bold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap tracking-wide uppercase text-sm">
              Contact
            </a>
          </div>

          <button className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </nav>
    </header>
  );
}